import { Container, Row, Col } from '@geberit/gdds';

// styles
import styles from '../text-image.module.scss';

// types
import type { OversizePanoramaProps } from '..';

// utils
import { buildSize, gridSizes } from 'utils/gridSize';

export function Oversize({
  image: Image,
  headline: Headline,
  caption: Caption,
  content: Content,
}: Readonly<OversizePanoramaProps>) {
  return (
    <>
      {Headline && (
        <Container maxContentWidth={buildSize(gridSizes.twoThird)}>
          <Row className={styles.row}>
            <Col className={styles.textCol}>
              <Headline />
            </Col>
          </Row>
        </Container>
      )}
      {(Caption || Image) && (
        <Container maxContentWidth={buildSize(gridSizes.twoThird, 12.75)}>
          <Row className={styles.row}>
            <Col className={styles.imageCol}>
              {Image && <Image />}
              {Caption && <Caption />}
            </Col>
          </Row>
        </Container>
      )}
      {Content && (
        <Container maxContentWidth={buildSize(gridSizes.twoThird)}>
          <Row className={styles.row}>
            <Col className={styles.textCol}>
              <Content />
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
}

